import { manifests as debugModalManifests } from './debug-modal/manifests.js';

export const manifests: Array<UmbExtensionManifest> = [...debugModalManifests];
